import React from 'react';
import { ContentType } from './types';

interface ContentGenerationOptionCardProps {
  icon: string;
  title: string;
  description?: string;
  contentType: ContentType;
  onClick: (contentType: ContentType) => void;
}

export const ContentGenerationOptionCard: React.FC<
  ContentGenerationOptionCardProps
> = ({ icon, title, description, contentType, onClick }) => {
  return (
    <div
      className="border border-[#3d3d3d] rounded-[10px] p-10 flex-col items-center justify-center cursor-pointer"
      onClick={() => onClick(contentType)}
    >
      <div className="w-[20px] h-[20px] mx-auto">
        <img src={icon} alt={title} />
      </div>
      <h3 className="text-white text-sm font-bold text-center">{title}</h3>
      {description && (
        <p className="text-[#707070] text-xs text-center">{description}</p>
      )}
    </div>
  );
};
